import { formStructure } from "pages/application/opportunities/edit/loanDetails/elements/borrower/formStructure";
import {
  dynamicFormFieldValidator,
  objParser,
} from "stories/components/FormRenderer/helpers";

export const LoanDetailsModel = () => {
  const updateGuarantor = async (obj) => {
    try {
      if (obj.guarantors)
        for (let i = 0; i < obj.guarantors.length; i++) {
          obj.guarantors[i] = await updateBorrower(obj.guarantors[i]);
        }
      else obj.guarantors = [];
      return obj.guarantors;
    } catch (e) {
      throw e;
    }
  };

  const updateOverview = async (obj) => {
    const floatFields = [
      "fee",
      "net_amount_requested",
      "premium",
      "interest_rate",
    ];
    floatFields.forEach((key) => {
      if (obj[key]) obj[key] = parseFloat(obj[key]);
    });
    if (isValidAmount(obj.net_amount_requested)) {
      if (obj.mortgage_broker_fee && obj.mortgage_broker_fee === "Flat Fee")
        delete obj.percentage;
      else if (obj.mortgage_broker_fee === "% Of Loan Amount") delete obj.fee;
      if (obj.proposed_interest_rate) {
        if (obj.proposed_interest_rate === "fixed") delete obj.premium;
        if (obj.proposed_interest_rate === "variable") delete obj.interest_rate;
      }
      if (obj.loan_structure === "interest only")
        delete obj.amortization_period;
      ["amortization_period", "loan_term", "loan_terms"].forEach((key) => {
        if (obj[key]) {
          if (isNaN(obj[key].count)) {
            delete obj[key];
          }
        }
      });

      return obj;
    }
  };

  const isValidAmount = (amount) => {
    return !isNaN(+amount);
  };

  const updateBorrower = async (obj) => {
    if (
      obj.corporate_structure === "corporation" ||
      obj.corporate_structure === "sole proprietorship"
    )
      delete obj.partners;

    const formFields = formStructure[obj.corporate_structure];
    const fieldsNames = dynamicFormFieldValidator(formFields, obj);
    fieldsNames["id"] = {};
    obj = objParser(obj, fieldsNames);

    return obj;
  };

  return Object.freeze({
    updateGuarantor,
    updateOverview,
    updateBorrower,
  });
};
